import { m } from "@/paraglide/messages.js";

/** Homepage teaser cards — keep this module free of full method-detail message imports. */
export type EglyMethodPillar = {
  n: string;
  title: string;
  summary: string;
};

export function getEglyMethodPillars(): EglyMethodPillar[] {
  return [
    {
      n: "01",
      title: m.method_content_step_01_title(),
      summary: m.method_content_step_01_summary(),
    },
    {
      n: "02",
      title: m.method_content_step_02_title(),
      summary: m.method_content_step_02_summary(),
    },
    {
      n: "03",
      title: m.method_content_step_03_title(),
      summary: m.method_content_step_03_summary(),
    },
  ];
}
